import { render, staticRenderFns } from "./BillingAdressSelector.vue?vue&type=template&id=60a15600&"
import script from "./BillingAdressSelector.vue?vue&type=script&lang=js&"
export * from "./BillingAdressSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports